import { Box, BoxProps } from '@mui/material';
import { Logo } from '../../assets';
import { COLORS } from '../../constants';
import { Transition } from '../transition';

/**
 * Top header with logo, extends MUI Box
 */
export const Header = (props: BoxProps) => {
  const { sx, ...rest } = props;
  return (
    <Box sx={{ backgroundColor: COLORS.surface.raised, zIndex: 2 }} data-testid="header">
      <Transition type="fadeDown">
        <Box
          component={'header'}
          {...rest}
          sx={{
            // White header over the lavender content, split by a brand hairline as in customer-mobile
            padding: 2,
            borderBottom: `1px solid ${COLORS.border.brand}`,
            top: 0,
            zIndex: 1,
            position: 'relative',
            display: { xs: 'flex', md: 'none' },
            ...sx,
          }}
        >
          <Logo height={28} />
        </Box>
      </Transition>
    </Box>
  );
};
